// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/set-user-status-request-schema',
  type: 'object',
  required: ['id', 'newStatusId'],
  properties: {
    id: {
      type: 'integer',
    },
    newStatusId: {
      type: 'integer',
    },
  },
} as IJSONSchema;

export default schema;
